import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import logoLight from '../assets/logo.svg';
import logoDark from '../assets/logo_white.svg';

const Logo = ({ sx = {}, ...props }) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  
  return (
    <Box
      component="img"
      src={isDarkMode ? logoDark : logoLight}
      alt="ERA Logo"
      sx={{
        height: 'auto',
        width: 'auto',
        maxWidth: '100%',
        maxHeight: 50,
        objectFit: 'contain',
        transition: 'all 0.3s ease-in-out',
        ...sx
      }}
      {...props}
    />
  );
};

export default Logo;
